import { get, find } from 'lodash';
import { getCurrentLanguage } from 'modules/language/selectors/language';

export default (state) => {
  const { siteLogo, siteLogoLabels, organizationLogo, organizationLogoLabels = [] } = state.auth.organizations;
  const currentLanguage = getCurrentLanguage().toUpperCase();
  const currentLogoLabels = organizationLogoLabels.length ? organizationLogoLabels : siteLogoLabels;
  const logoLabel = find(currentLogoLabels, { locale: currentLanguage });

  return {
    organizationLogo: organizationLogo || siteLogo,
    logoLabel: get(logoLabel, 'value', ''),
  };
};
